export default "__VITE_ASSET__a5ba477a__"